import { useState } from 'react'
import { SocialDocument } from '../../../../model/domain/social-document'
import FileIcon from '../../../common/components/FileIcon/FileIcon'
import './DocumentCard.scss'
import { User } from '../../../../model/domain/user'
import { Role } from '@cuatroochenta/co-admin-react-library'

interface DocumentCardProps {
    user?: User
    socialDocument: SocialDocument
    onDocumentClick: (socialDocument: SocialDocument) => void
    onDeleteClick: (socialDocumentId: SocialDocument['id']) => void
}

function DocumentCard({
    user,
    socialDocument,
    onDocumentClick,
    onDeleteClick,
}: DocumentCardProps) {
    const [showDeleteButton, setShowDeleteButton] = useState(false)

    const handleMouseEnter = () => {
        if (
            user?.data.roles.includes(Role.SUPERADMIN) ||
            user?.data.id === socialDocument.userId
        ) {
            setShowDeleteButton(true)
        }
    }

    const handleMouseLeave = () => {
        setShowDeleteButton(false)
    }

    const handleDeleteClick = (event: React.MouseEvent) => {
        event.stopPropagation()
        onDeleteClick(socialDocument.id)
    }

    return (
        <div
            key={socialDocument.id}
            className="document-card"
            onClick={() => onDocumentClick(socialDocument)}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            <FileIcon />
            <span>{socialDocument.filename}</span>
            {showDeleteButton && (
                <button onClick={handleDeleteClick}>
                    <i className="fa fa-trash" />
                </button>
            )}
        </div>
    )
}

export default DocumentCard
